module.exports = __webpack_public_path__ + "static/media/beer.8ebd125b.jpg";